/**
 * Created by calhosh on 2/12/2025
 */
import React, {useCallback, useState} from 'react';
import {entities, entityTypes, reviewNoteStatus, rnhEngagementSources} from '../../../util/uiconstants';
import {currentResource, labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {cleanSelectedNotes, getNoteDetail} from '../../../actions/NotesModal/rnhnotedetailaction';
import NotesHeader from './Header';
import {clearErrors} from '../../../actions/erroractions';
import {setIsMediaPlaying} from '../../../actions/MediaPlaying/mediaPlayingAction';
import {setIsModalOpen} from '../../../actions/setismodalopen';
import NotesModalWrapper from '../NotesModalWrapper';
import {useUserPreferences} from '../../../util/customHooks';
import {useIsAresView} from '../../../util/Ares/customHooks';
import {useDispatch} from 'react-redux';

export default function CanvasFormOnlyReviewNotes({document, engagementId, viewKey, entityUId, setShowNotesModal}) {
	const [externalLoading, setExternalLoading] = useState(false);
	const userPreferences = useUserPreferences();
	const isAresView = useIsAresView();
	const dispatch = useDispatch();

	const onHide = useCallback((event) => {
		setShowNotesModal(false);
	}, []);

	const renderModal = () => {
		const modalProps = {
			parentName: 'documentNotes',
			document: document,
			entityId: document.id,
			entityUId: entityUId,
			viewKey: viewKey,
			engagementId: engagementId,
			entityType: entityTypes.Document,
			reviewnoteType: 2,
			messagePlaceHolder: labels.placeholderForSearch,
			isAresView: isAresView
		};

		const getAllDetails = () => {
			let requestsUrl = Utility.getAnnotationsUrl(
				undefined,
				document?.id || document?.value || modalProps.entityId,
				engagementId,
				entities.Document,
				true,
				true,
				true,
				[reviewNoteStatus.Open.id, reviewNoteStatus.Cleared.id, reviewNoteStatus.Closed.id],
				null,
				null,
				null,
				null,
				1000,
				null,
				rnhEngagementSources.allEngagements
			);

			dispatch(
				getNoteDetail(
					requestsUrl,
					false,
					false,
					{isModalRequest: true, engagementId: parseInt(engagementId), currentUserId: userPreferences.id},
					modalProps.entityId
				)
			);
		};

		const renderDetails = () => {
			const props = {
				entityType: entityTypes.Document,
				parentName: null,
				document,
				engagementId,
				setIsLoading: setExternalLoading
			};

			return <NotesHeader {...props} />;
		};

		const props = {
			entityUId: entityUId,
			show: true,
			onClose: () =>
				dispatch(clearErrors())
					.then(() => {
						dispatch(setIsMediaPlaying(false));
						dispatch(setIsModalOpen(false));
						dispatch(cleanSelectedNotes(true));
					})
					.then(() => onHide()),
			entityId: document?.id,
			renderDetails,
			externalLoading,
			instructionalText: currentResource?.reviewNoteModalLabels?.notesModalInstructionalText.replace(
				'{0}',
				currentResource.reviewNoteModalLabels.documentLabel.toLowerCase()
			),
			handleGetNotes: getAllDetails,
			headerLabel: currentResource?.reviewNoteModalLabels?.documentReviewNotesLabel,
			disableAdd: false,
			disableFilters: false,
			viewKey: viewKey,
			bodyId: entityUId
		};

		return <NotesModalWrapper {...props} />;
	};
	return <>{renderModal()}</>;
}
